import { Button, Icon, Modal, Text } from '@pukka/ui-components';

interface OutletStatusProps {
  readonly status: string;
  readonly onClickRegister: () => void;
}

interface EwalletStatusModalProps {
  readonly open: boolean;
  readonly data: { name: string; status: string }[];
  readonly onToggleModal?: (open: boolean) => void;
  readonly onClickRegister: () => void;
}

function OutletStatus({ status, onClickRegister }: OutletStatusProps) {
  switch (status) {
    case 'APPROVED':
      return <Text className="text-green-500">✅ Active</Text>;
    case 'PENDING':
      return <Text className="text-yellow-500">⌛️ On Progress</Text>;
    case 'REJECTED':
      return (
        <Text>
          🚫{' '}
          <Text as="span" className="text-red-500">
            Rejected
          </Text>
          . Contact us at{' '}
          <Text as="span" color="blue" className="underline" weight="bold">
            1500970
          </Text>
        </Text>
      );
    default:
      return (
        <Button size="s" onClick={onClickRegister}>
          Start Registration
        </Button>
      );
  }
}

function EwalletStatusModal({ open, data, onToggleModal, onClickRegister }: EwalletStatusModalProps) {
  return (
    <Modal unwrap open={open} onOpenChange={onToggleModal}>
      <Modal.Content className="bg-neutral-50 md:w-144">
        <Modal.Title className="flex-row justify-between">
          Outlet Status
          <Modal.Trigger asChild>
            <Button variant="nude" size="none" className="rounded-md">
              <Icon icon="close" color="white" />
            </Button>
          </Modal.Trigger>
        </Modal.Title>
        <Modal.Body className="max-h-128">
          {data?.map((outlet, idx) => {
            return (
              <div key={idx} className="flex h-16 items-center justify-between">
                <Text variant="subtitle-2">{outlet.name}</Text>
                <OutletStatus status={outlet.status} onClickRegister={onClickRegister} />
              </div>
            );
          })}
        </Modal.Body>
      </Modal.Content>
    </Modal>
  );
}

export { EwalletStatusModal, OutletStatus as EwalletOutletStatus };
